import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getDashboardData = createAsyncThunk("dashboard/getDashboardData", async ({ startDate = null, endDate = null } = {}, { rejectWithValue }) => {
  const params = {};
  if (startDate || endDate) {
    params.dateFilter = {};
    if (startDate) params.dateFilter.startDate = startDate;
    if (endDate) params.dateFilter.endDate = endDate;
  }

  try {
    const response = await apiInstance.get("/dashboard", {
      headers: authHeader(),
      params,
    });
    return response;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

const initialState = {
  dashboardData: [],
  dashboardLoading: true,
};

const dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState,
  reducers: {
    setDashboardLoading: (state, action) => {
      state.dashboardLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.dashboardData = action.payload.data;
      state.dashboardLoading = false;
    });
  },
});
export default dashboardSlice.reducer;
export const { setDashboardLoading } = dashboardSlice.actions;